import createModel from "../createModel";

export const ClientVerification = createModel("ClientVerification", (json) => ({
    isVerified: json.IsVerified,
    requestDate: json.RequestDate,
    confirmDate: json.ConfirmDate,
    denyReason: json.ClientVerificationDenyReason,
    denyReasonComment: json.DenyReasonComment,
}));
